﻿let authForm = {};

authForm = {
  activeAttempt: null,
  messageTimer: null,
	el: {
		root: document.querySelector(".auth-form"),
		navButtons: document.querySelectorAll(".auth-form__nav-button"),
		forms: document.querySelectorAll(".auth-form__form"),
		methods: document.querySelector(".auth-form__method"),
		steps: document.querySelectorAll(".auth-form__step"),
		simForm: document.querySelector('.auth-form__form[data-method="sim"]'),
		appForm: document.querySelector('.auth-form__form[data-method="app"]'),
		message: document.querySelector(".auth-form__message"),
		inputs: document.querySelectorAll(".auth-form .auth-form__input"),
		challengeText: document.querySelector(".auth-form__challenge-text"),
    banner: document.querySelector(".banner")

	},
	init: function() {
    this.handleNav();
		this.formEvents();
		this.inputEvents();
    window.addEventListener('pagehide', () => this.cancelAttempt());
    
    if (this.el.banner) {
      this.handleBanner(this.el.banner);
      window.addEventListener('resize', () => this.handleBanner(this.el.banner))
    }
	},
  handleBanner(banner) {
    const bannerText = banner.querySelector('.banner__subcaption')
    if (bannerText) {
      if (window.innerWidth < 776) {
        bannerText.style.display = "none";
        banner.style = "padding-top: 100px;"
      }
      else {
        bannerText.style.display = "block";
        banner.style = "padding-top: 210px;"
      }
    }
  },

	handleSubmit(form) {
    if (!form) {
      return;
    }
		form.addEventListener("submit", (e) => {
			e.preventDefault();
      if (this.activeAttempt) {
        return;
      }
      const attempt = {
        form,
        controller: new AbortController(),
        deadline: Date.now() + 120000,
        buttons: Array.from(form.querySelectorAll('button[type="submit"]')).map((button) => {
          const spinner = button.querySelector('.spinner');
          const text = button.querySelector('.button__text');
          const state = {
            button, spinner, text,
            disabled: button.disabled,
            disabledClass: button.classList.contains('button--disabled'),
            spinnerHidden: spinner?.classList.contains('hide'),
            spinnerDisplay: spinner?.style.display,
            textVisibility: text?.style.visibility
          };
          button.disabled = true;
          button.classList.add('button--disabled');
          if (spinner) {
            spinner.classList.remove('hide');
            spinner.style.display = 'block';
          }
          if (text) {
            text.style.visibility = 'hidden';
          }
          return state;
        })
      };
      this.activeAttempt = attempt;
      this.handleMessage(false);
      attempt.timer = setTimeout(() => this.failAttempt(attempt, 'ERR_TIMEOUT'), 120000);
      this.submitAttempt(attempt);
		});
	},
  isActive(attempt) {
    return this.activeAttempt === attempt && !attempt.controller.signal.aborted;
  },
  async request(attempt, action, token, body) {
    const response = await fetch(`/umbraco/surface/mypagesauth/${action}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        RequestVerificationToken: token
      },
      body: JSON.stringify(body),
      signal: attempt.controller.signal
    });
    const data = await response.json();
    if (!response.ok) {
      const error = new Error('Authentication request failed');
      error.authCode = typeof data?.message === 'string' ? data.message : undefined;
      throw error;
    }
    if (!data || typeof data !== 'object' || Array.isArray(data)) {
      throw new Error('Invalid authentication response');
    }
    return data;
  },
  async submitAttempt(attempt) {
    try {
      const token = attempt.form['__RequestVerificationToken'].value;
      const formData = this.getFormData(attempt.form);
      const data = await this.request(attempt, 'login', token, {
        culture: formData.culture,
        authType: formData.authType,
        id: formData.id,
        phone: formData.phone || '',
        ssn: formData.ssn || '',
        ufprt: formData.ufprt
      });
      if (!this.isActive(attempt) || this.completeAttempt(attempt, data)) {
        return;
      }
      if (!this.isValidIdentifier(data.identifier) ||
          typeof data.challenge !== 'string' || !data.challenge.trim()) {
        this.failAttempt(attempt, data.message);
        return;
      }
      await this.poll(data, token, attempt);
    } catch (error) {
      this.failAttempt(attempt, error?.authCode);
    }
  },
  completeAttempt(attempt, data) {
    if (Date.now() >= attempt.deadline) {
      this.failAttempt(attempt, 'ERR_TIMEOUT');
      return true;
    }
    if (data.success && data.redirect) {
      this.cancelAttempt();
      window.location.href = window.location.origin + data.redirect;
      return true;
    }
    if (data.success === false && !data.pending) {
      this.failAttempt(attempt, data.message);
      return true;
    }
    return false;
  },
  async poll(res, antiforgeryToken, attempt) {
    this.changeStep(2, res);
    while (this.isActive(attempt)) {
      const data = await this.request(attempt, 'poll', antiforgeryToken, {
        culture: 'is-IS',
        authIdentifier: res.identifier,
        id: attempt.form.querySelector('input[name="id"]').value
      });
      if (!this.isActive(attempt) || this.completeAttempt(attempt, data)) {
        return;
      }
      if (!data.pending) {
        this.failAttempt(attempt, data.message);
        return;
      }
      const requestedDelay = Number(data.retryAfterMs);
      const delay = Math.min(
        Number.isFinite(requestedDelay) ? Math.max(500, requestedDelay) : 2000,
        5000,
        Math.max(0, attempt.deadline - Date.now())
      );
      await new Promise((resolve) => {
        const finish = () => {
          clearTimeout(attempt.retryTimer);
          attempt.controller.signal.removeEventListener('abort', finish);
          resolve();
        };
        attempt.retryTimer = setTimeout(finish, delay);
        attempt.controller.signal.addEventListener('abort', finish, { once: true });
      });
      if (this.isActive(attempt) && Date.now() >= attempt.deadline) {
        this.failAttempt(attempt, 'ERR_TIMEOUT');
      }
    }
  },
  cancelAttempt() {
    const attempt = this.activeAttempt;
    if (!attempt) {
      return;
    }
    this.activeAttempt = null;
    clearTimeout(attempt.timer);
    attempt.controller.abort();
    this.resetSubmitButton(attempt.form, attempt);
    this.changeStep(1);
  },
  failAttempt(attempt, message) {
    if (this.isActive(attempt)) {
      this.cancelAttempt();
      this.handleMessage(true, 'error', message);
    }
  },
  isValidIdentifier(identifier) {
    return typeof identifier === 'string' && identifier.trim() &&
      identifier !== "00000000-0000-0000-0000-000000000000";
  },
  resetSubmitButton(form, attempt = this.activeAttempt) {
    if (attempt?.form === form) {
      attempt.buttons.forEach((state) => {
        state.button.disabled = state.disabled;
        state.button.classList.toggle('button--disabled', state.disabledClass);
        if (state.text) {
          state.text.style.visibility = state.textVisibility;
        }
        if (state.spinner) {
          state.spinner.classList.toggle('hide', state.spinnerHidden);
          state.spinner.style.display = state.spinnerDisplay;
        }
      });
    }
  },
	handleMessage(show = false, type = "error", code) {
    clearTimeout(this.messageTimer);
    if (!this.el.message) {
      return;
    }
		if (show) {
      const messages = {
        ERR_NO_APP_USER: 'Enginn notandi fannst í Auðkennisappinu. Skráðu þig í appið og reyndu aftur.',
        ERR_AUTH_USERAUTHERROR: 'Auðkenning tókst ekki. Reyndu aftur.',
        ERR_TIMEOUT: 'Auðkenning rann út á tíma. Reyndu aftur.'
      };
      const paragraph = this.el.message.querySelector('p');
      if (paragraph) {
        paragraph.textContent = Object.prototype.hasOwnProperty.call(messages, code)
          ? messages[code]
          : 'Villa kom upp. Reyndu aftur.';
      }
			this.el.message.style.display = "block";

			this.messageTimer = setTimeout(() => {
				this.el.message.style.display = "none";
			}, 10000);
		} else {
			this.el.message.style.display = "none";
		}

		this.el.message.classList.add(`message--${type}`);
	},
	getFormData(form) {
		const formData = new FormData(form);
		const plainFormData = {};
		// @ts-ignore
		for (const [key, value] of formData.entries()) {
			plainFormData[key] = value;
		}

		return plainFormData;
	},
	changeStep(stepNumber, request = null) {
		this.el.steps.forEach((step) => {
			step.style.display = "none";
		});
		const chosenStep = this.el.root.querySelector(
			`.auth-form__step[data-step="${stepNumber}"]`
		);
		if (chosenStep) {
			chosenStep.style.display = "block";
		}

		if (stepNumber === 2) {
			this.el.challengeText.innerText = request.challenge;
		}
	},
	handleNav() {
		this.el.navButtons.forEach((button) => {
			button.addEventListener(
				"click",
				(e) => {
					this.changeForm(button.dataset.method);
				},
			);
		});
	},
	changeForm(method) {
    this.cancelAttempt();
    this.handleMessage(false);
		this.el.forms.forEach((item) => {
			item.classList.remove("auth-form__form--active");
		});
		this.el.navButtons.forEach((button) => {
			button.classList.remove("auth-form__nav-button--active");
		});
    const methodForm = this.el.root.querySelector(`.auth-form__form[data-method="${method}"]`)
    const methodBtn = this.el.root.querySelector(`.auth-form__nav-button[data-method="${method}"]`)
		if (methodForm) {
			methodForm.classList.add("auth-form__form--active");
    }
    if (methodBtn) {
      methodBtn.classList.add("auth-form__nav-button--active");
    }
		
	},
	formEvents() {
    // not handling login__form here
    this.handleSubmit(this.el.simForm)
    this.handleSubmit(this.el.appForm)
	},
	inputEvents() {
		this.el.inputs.forEach((input) => {
			// This prevents ctrl + v
			input.onpaste = (e) => e.preventDefault();

			input.addEventListener(
				"keyup",
				(e) => {
					if (e.key !== "Backspace") {
						const regex = /^[0-9-]*$/;

						if (!regex.test(e.target.value)) {
							// If the input doesn't match the pattern, clear the input value
							e.target.value = e.target.value.replace(/[^0-9-]/g, "");
						}
					}

					const parent = e.target.closest(
						".auth-form__input-wrap"
					);

          if (parent) {
            const submitBtn = parent.querySelector(".auth-form__submit")
            if (submitBtn) {
              if (this.activeAttempt?.form === input.closest('form')) {
                return;
              }
              const inputLength = e.target.value.length;
              const maxLength = e.target.maxLength;
              const isSim = maxLength == 8;
              const isApp = maxLength == 11;
              if (inputLength == maxLength) {
                if ((isSim && e.target.value[3] == '-') || (isApp && e.target.value[6] == '-')) {
                  submitBtn.removeAttribute("disabled");
                } 
                else {
                  submitBtn.setAttribute("disabled", "");
                }
              } 
              else if (inputLength == maxLength - 1) {
                if (!e.target.value.includes('-')) {
                  
                  submitBtn.removeAttribute("disabled");
                } 
                else {
                  submitBtn.setAttribute("disabled", "");
                }
              }
              
              else {
                submitBtn.setAttribute("disabled", "");
              }

            }
          }

				},
			);
		});
	},
};

authForm.initialize = function () {
  authForm.init();
};

module.exports = authForm;
